import { Component } from '@angular/core';
import {ExamPrePostHeroComponent} from "./exam-pre-post-hero/exam-pre-post-hero.component";
import {InfoComponent} from "../home/info/info.component";
import {InfoProcedimientosPPComponent} from "./info-procedimientos-pp/info-procedimientos-pp.component";
import {FooterPersonaComponent} from "../../app-persona/footer-persona/footer-persona.component";

@Component({
  selector: 'app-examenes-pre-post-ocupacional',
  standalone: true,
    imports: [
        ExamPrePostHeroComponent,
        InfoComponent,
        InfoProcedimientosPPComponent,
        FooterPersonaComponent
    ],
  templateUrl: './examenes-pre-post-ocupacional.component.html',
  styleUrl: './examenes-pre-post-ocupacional.component.css'
})
export class ExamenesPrePostOcupacionalComponent {


}
